<template>
    <div class="pb-0 group-title-wrapper" v-if="!disabled">
	<div class="type-label">Campaign</div>
	<div class="group-title">
	    <h1 class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle" @click="activateTitleField">{{ socialCampaignDetail.title }}</h1>
	    <input
	        ref="editTitleRef"
	        v-show="editTitle"
	        type="text"
	        placeholder="Social Media Campaign..."
	        class="form-control mb-3 title-field exclude-outside-click h1"
	        v-model="socialCampaignDetail.title"
	        v-click-outside="clickOutsideTitle"
	        @change="updateSocialCampaign()"
	    />
	</div>
   	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters } from "vuex";
import CreateLinkModal from "./CreateSocialCampaignLinkModal";
import EditLinkModal from "./EditSocialCampaignLinkModal";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import CustomFields from './SocialCampaignCustomFields.vue';


export default {
    props: ['isEdit', 'disabled'],
    components: {
        'vuejs-datepicker': Datepicker,
        CreateLinkModal,
        EditLinkModal,
        LinkCopyLinkModal,
        CustomFields
    },
    data() {
        const loggedInUser = {id: localStorage.getItem("userId"), name: localStorage.getItem("user")};
        return {
            editTitle: false,
            emEditing: false,
            plEditing: false,
            budgetEditing: false,
            requisitionNumberEditing: false,
            socialCampaign: {
                title: "Social Media Campaign",
                start_date: this.$moment().format(),
                end_date: null,
                engagement_manager: loggedInUser,
                project_lead: loggedInUser,
                budget: null,
                requisitionNumber: "",
            },
            showRemoveSocialCampaign: false,
            // Resources
            linkUrl: null,
            linkLabel: null,
            linkNotes: null,
            linkType: null,
            editLinkIsFile: false,
            linkCopyModalValue: "",
        };
    },
    computed: {
        ...mapGetters([
            'allActiveUsers',
            'allCustomFields',
            'socialCampaignDetail',
            "userAbilities",
        ]),
        optionsForLinkType() {
            let linkTypeField = this.allCustomFields.find(x => x.id == 37);
            if (!linkTypeField) {
                this.$store.dispatch("fetchAllCustomFields");
            } else {
                return JSON.parse(linkTypeField.value_set);
            }
		},
        _() {
            return _;
        },
        userCanEditSocialCampaign() {
			const userId = localStorage.getItem("userId");
            const socialCampaign = this.socialCampaignDetail;

            if (this.userAbilities.accessAllSocialCampaigns) {
                return this.userAbilities.editSocialCampaign;
            }

            let isManager = false;
            if (socialCampaign.engagement_manager instanceof Object) {
                isManager = userId == socialCampaign.engagement_manager.id;
            } else {
                isManager = userId == socialCampaign.engagement_manager;
            }

            return (this.userAbilities.editSocialCampaign && isManager);
        },
    },
    methods: {
        ...mapActions([
            'createSocialCampaign',
            'updateSocialCampaignFieldValue',
        ]),
        activateTitleField() {
            this.editTitle = true;
            let that = this;
            setTimeout(() => {
                that.$refs.editTitleRef.select();
            }, 100);
        },
        clickOutsideTitle() {
            this.editTitle = false;
        },

        showEngagementManager() {
            this.emEditing = true;
            this.$nextTick(() => {
                this.$refs.emSelect.$el.focus();
            })
        },
        showProjectLead() {
            this.plEditing =  true;
            this.$nextTick(() => {
                this.$refs.plSelect.$el.focus();
            })
        },
        changeEngagementManager(v1, v2) {
            
        },
        changeProjectLead() {

        },

        clickOutsideEM() {
            this.emEditing = false;
        },
        clickOutsidePL() {
            this.plEditing = false;
        },

        onToday(dateType) {
            if (dateType == "startDate") {
                this.socialCampaign.start_date = this.$moment().format();
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialCampaign.end_date = this.$moment().format();
                this.$refs.endDatePicker.close();
            }
        },
        onRemoveDate(dateType) {
            if (dateType == "startDate") {
                this.socialCampaign.start_date = null;
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialCampaign.end_date = null;
                this.$refs.endDatePicker.close();
            }
        },

        createCampaign() {
            this.socialCampaign.engagement_manager = this.socialCampaign.engagement_manager.id;
            this.socialCampaign.project_lead = this.socialCampaign.project_lead.id;

            this.createSocialCampaign(this.socialCampaign);

            this.$emit("socialCampaignCreated", this.socialCampaign);
        },

        close() {
            this.$emit("socialCampaignClose");
        },


        budgetClick() {
            this.budgetEditing = true;
            setTimeout(() => {
                this.$refs.budgetInput.select();
            }, 100);
        },
        budgetClickOutside() {
            this.budgetEditing = false;
        },

        requisitionNumberClick() {
            this.requisitionNumberEditing = true;
            setTimeout(() => {
                this.$refs.requisitionNumberInput.select();
            }, 100);
        },
        requisitionNumberClickOutside() {
            this.requisitionNumberEditing = false;
        },

        showResourceBox(url, parent_id) {
            let fileId = this.customChildFieldValue('file_id',parent_id);
            return (url != null || fileId != null);
        },
        customChildField(key, parent_id) {
            if (this.socialCampaignDetail.customFields) {
                let obj = _.filter(this.socialCampaignDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                    // lets add it to the
                    return obj;
                } else {
                    if (key == 'file_id') return null;
                    if (key == 'link_type') return [];
                    // return the global version of the custom field...
                    // let obj = _.filter(this.allCustomFields, {field_key: key});
                    let field = _.filter(this.allCustomFields, {field_key: key});
                    obj = {};
                    obj.id = null;
                    obj.parent_id = this.socialCampaignDetail.customFields[index].id;
                    obj.social_campaign_id = this.socialCampaignDetail.customFields[index].social_campaign_id;
                    obj.editing = false;
                    obj.field_id = field[0].id;
                    obj.field_key = field[0].field_key;
                    obj.field_parent_id = field[0].parent_id;
                    obj.field_type = field[0].field_type;
                    obj.note = field[0].note;
                    obj.value = null;
                    obj.label = field[0].label;
                    obj.value_set = field[0].value_set;
                    obj.updated_at = this.socialCampaignDetail.customFields[index].updated_at;
                    return [obj];
                }
            }
            return [];
        },
        customChildFieldValue(key, parent_id) {
            if (this.socialCampaignDetail.customFields) {
                let obj = _.filter(this.socialCampaignDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                return obj[0].value;
                } else {
                return null;
                }
            }
            return null;
        },

        // Resources
        addResourceMenuItemClick(typeId, e) {
            e.preventDefault();
            this.addResource(typeId);
        },
        editResource(resource) {
            this.linkUrl = resource;
            let label =  this.customChildField('link_label', resource.scfv_id);
            if (label.length > 0) {
                this.linkLabel = label[0];
            } else {
                this.linkLabel = {};
            }
            let notes =  this.customChildField('link_notes', resource.scfv_id);
            if (notes.length > 0) {
                this.linkNotes = notes[0];
            } else {
                this.linkNotes = {};
            }
            let type = this.customChildField('link_type', resource.scfv_id);
            if (type.length > 0) {
                this.linkType = type[0];
            } else {
                this.linkType = {
                id:null,
                field_id:37,
                social_campaign_field_id: _.filter(this.socialCampaignDetail.customFields, {field_key: 'link_type'})[0]?.socialCampaignFieldId,
                parent_field_id: 20,
                field_key: "link_type",
                field_type: "select",
                parent_id: null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:1
                };
            }
            let fileId = this.customChildField('file_id', resource.scfv_id);
            this.editLinkIsFile = Boolean(fileId);
            this.$bvModal.show("editLinkModal");
        },
        addResource(typeId = 1) {
            this.linkUrl = {
                id:null,
                field_id:20,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_url'})[0].socialCampaignFieldId,
                parent_field_id:null,
                field_key:"link_url",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkLabel = {
                id:null,
                field_id:21,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_label'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_label",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkNotes = {
                id:null,
                field_id:22,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_notes'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_notes",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkType = {
                id:null,
                field_id:37,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_type'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_type",
                field_type:"select",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:typeId
            };
            this.$bvModal.show("createLinkModal");
        },
        focusLinkModal() {
            this.$refs.refLinkModal.focusMyElement();
        },
        focusEditLinkModal() {
            this.$refs.refEditLinkModal.focusMyElement();
        },
        removeSocialCampaign() {
          this.showRemoveSocialCampaign = true;
        },

        onConfirmRemoveSocialCampaign() {
          if (this.socialCampaignDetail.id) {
            let that = this;
            let socialCampaignId = this.socialCampaignDetail.id;
            let socialCampaignTemplateId = this.socialCampaignDetail.socialCampaign_template_id;
            this.$store.dispatch("removeSocialCampaign", { socialCampaignId:this.socialCampaignDetail.id }).then(function() {
              that.$bvModal.hide("editSocialCampaignModal");
              // TODO: removing a socialCampaign should only remove it from the list, not replace entire list.

              that.$store.dispatch('fetchSocialCampaigns').then(function() {
                // toast.hide();

                // if (socialCampaignTemplateId == 1) {
                // 	that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
                // } else {
                // }
                that.$store.dispatch('manageUndoActivation', 'SocialCampaign deleted.');

              	// that.$store.dispatch('fetchProjectSocialCampaign');
              });
            });
          }
        },

        updateSocialCampaign() {
            this.$store.dispatch("updateSocialCampaign", this.socialCampaignDetail);
        },

        getLinkTypeObject(id) {
            if (id == null) id = 1;
            const r = this.optionsForLinkType.find(x => x.id == id);
            return r;
        },

        openCopyLinkModal(link, e, i) {
            if (!link.includes("\\")) {
                return;
            }
            e.preventDefault();
            this.copyLink(link, i);
        },
        async copyLink(link, resourceId) {
            clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
            Object.keys(this._.filter(this.socialCampaignDetail.customFields, {field_key: 'link_url'})).forEach(x => {
                if (x == resourceId) return;
                this.$root.$emit('bv::hide::tooltip', 'social-campaign-resource-' + x);
            })

            const navPer = await navigator.permissions.query({name: "clipboard-write"});
            if (navPer.state == "granted" || navPer.state == "prompt") {
                try {
                    await navigator.clipboard.writeText(link);
                } catch {
                    console.error("clipboard API error. Cannot copy to clipboard.");
                    this.legacyCopyMethod(link);
                }
            } else {
                this.legacyCopyMethod(link);
            }

            this.$root.$emit('bv::show::tooltip', 'social-campaign-resource-' + resourceId);
            this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
                this.$root.$emit('bv::hide::tooltip', 'social-campaign-resource-' + resourceId);
            }, 2000);
        },
    },
    mounted() {
        //console.log(this.socialCampaignDetail);
    },
}
</script>
<style scoped>
.type-label {
	color: #4C9850;
display:block;
font-weight: 400;
font-size: 1em;
text-transform:uppercase;
}
h1 {
	font-size:22px;
}
.group-title-wrapper {
	width:100%;
	}
h1.edit-d-title::after {
	/*color: #2D3135;*/
	background:transparent;
	right:-40px;
	}
.group-title-wrapper {

	}
textarea.title-field {
	font-size:22px;
}
</style>